import httpClient from "@/services/httpClient";
import { server, dispute_resolution_const } from "@/services/constants";

const api_core = `${dispute_resolution_const.dispute_resolution_url}`

export const dispute_resolution_getall_additional_lawyers = () => {
    return httpClient.get(`${api_core}/${server.LITIGATION_ADDITIONAL_LAWYERS}/`);
};
export const dispute_resolution_getbyid_additional_lawyers = (id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_ADDITIONAL_LAWYERS}/by-id/${id}`);
};
export const dispute_resolution_add_additional_lawyers = (data) => {
    return httpClient.post(`${api_core}/${server.LITIGATION_ADDITIONAL_LAWYERS}/`, data);
};
export const dispute_resolution_update_additional_lawyers = (id, data) => {
    return httpClient.put(`${api_core}/${server.LITIGATION_ADDITIONAL_LAWYERS}/${id}`, data);
};
export const dispute_resolution_delete_additional_lawyers = (id) => {
    return httpClient.delete(`${api_core}/${server.LITIGATION_ADDITIONAL_LAWYERS}/${id}`);
};
export const dispute_resolution_delete_additional_lawyer_by_user = (litigation_docket_id, user_id) => {
    return httpClient.delete(`${api_core}/${server.LITIGATION_ADDITIONAL_LAWYERS}/by-user/${litigation_docket_id}/${user_id}`);
};
